<span *ngIf="isParsed" class="font-weight-500" [ngClass]="{'green-fg': sign(data) == 1, 'warn-fg': sign(data) == -1}">
  <ng-container *ngIf="!noSymbol">
    {{ data | currency:'IDR':'Rp ':'1.2-2':'id'}}
  </ng-container>
  <ng-container *ngIf="noSymbol">
    {{ data | currency:'IDR':'':'1.2-2':'id'}}
  </ng-container>
</span>
<span *ngIf="!isParsed">
  {{ data }}
</span>
